export default __webpack_public_path__ + "static/media/mobile_loyalt.95049b17.png";